<template>
  <div id="app">
    <router-view />
    <AppUpdateDialog />
  </div>
</template>

<script>
import AppUpdateDialog from '@/components/AppUpdateDialog.vue'

export default {
  name: 'App',
  components: { AppUpdateDialog }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  height: auto;
  margin: 0;
  padding: 0;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #f5f5f5;
}
</style>
